import * as React from 'react';
import { SVGProps } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Ebene_1"
    x={0}
    y={0}
    style={{
      background: 'new 0 0 16 13.4192705',
    }}
    viewBox="0 0 16 13.419"
    {...props}
  >
    <style>
      {
        '.st0{fill:#4f96aa}.st1{fill:#007a92}.st2{fill:#00566a}.st3{fill:#6cc4d0}.st4{fill:#5097ab}'
      }
    </style>
    <circle cx={6.005} cy={1.283} r={1.282} className="st0" />
    <circle cx={2.026} cy={8.386} r={2.026} className="st0" />
    <circle cx={13.024} cy={11.707} r={1.713} className="st0" />
    <path
      d="M7.607 6.816a.692.692 0 0 1 1.157-.698l4.1 4.317a.691.691 0 1 1-1.004.953L7.761 7.07a.685.685 0 0 1-.154-.255z"
      className="st1"
    />
    <path
      d="m12.863 10.435-.34-.358a1.708 1.708 0 0 0-1.046.907l.383.404a.691.691 0 1 0 1.003-.953z"
      className="st2"
    />
    <path
      d="M2.772 8.44a.692.692 0 0 1 .435-.876l4.836-1.625a.692.692 0 0 1 .44 1.311L3.649 8.875a.692.692 0 0 1-.876-.435z"
      className="st1"
    />
    <path
      d="m3.777 7.372-.57.192a.692.692 0 0 0 .44 1.311l.37-.124a2.015 2.015 0 0 0-.24-1.38z"
      className="st2"
    />
    <circle cx={8.247} cy={6.473} r={2.824} className="st3" />
    <circle cx={14.066} cy={2.676} r={1.934} className="st4" />
    <path
      d="M5.46 1.951a.692.692 0 0 1 1.319-.292L8.92 6.32a.692.692 0 1 1-1.254.584l-2.142-4.66a.684.684 0 0 1-.064-.292z"
      className="st3"
    />
    <path
      d="M6.779 1.66a.692.692 0 0 0-1.255.583l.122.265c.115.034.234.057.36.057.394 0 .742-.181.977-.461l-.204-.445z"
      className="st2"
    />
    <path
      d="M13.813 3.648a.683.683 0 0 1-.203.218L8.7 7.235a.692.692 0 0 1-.782-1.141l4.907-3.369a.691.691 0 0 1 .987.923z"
      style={{
        fill: '#79aebf',
      }}
    />
    <path
      d="M10.257 4.49 8.602 5.624 7.717 3.7c-.47.09-.898.294-1.254.585l1.194 2.598c.02.06.045.118.082.172a.692.692 0 0 0 .962.18l2.257-1.55a2.82 2.82 0 0 0-.701-1.196z"
      className="st4"
    />
    <path
      d="m8.953 6.34-.329-.715-.704.483a.711.711 0 0 0-.27.814l.01.021a.714.714 0 1 0 1.293-.602zM12.826 2.725l-.626.43c.12.469.406.87.798 1.13l.612-.42a.692.692 0 0 0-.783-1.14z"
      className="st2"
    />
  </svg>
);
export default SvgComponent;
